import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import cartConfig from 'emun.cart/cart.config'
import templateUrl from 'emun.cart/cart-select-notes.htm'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

class controller {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		if (options) { $ctrl.item = options.item }
        $ctrl.title = `Notes`;
		$ctrl.notes = new AutoQuery({
			url: 'QueryNotes.json',
			orderBy: 'NoteText',
			autoLoad: true,
			pageSize: 100
		})
	}
	selectNote(note) {
		let $ctrl = this;
		$ctrl.item.notes = ($ctrl.item.notes || "")  + " " + note.noteText;
		$ctrl.$cart.changeOptions($ctrl.item);
		$ctrl.$dismiss();
	}
}

export default (options) => modals.open(Object.assign({
    size: 'md',
    templateUrl,
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;